import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=67012c93"
import script from "./Vendors.vue?vue&type=script&lang=ts"
export * from "./Vendors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports